module.exports = __webpack_public_path__ + "media/27.89d0c039.ogg";